import { LegacyText } from '@lemonade-hq/cdk';
import dynamic from 'next/dynamic';
import styled from 'styled-components';

const ResponsiveText = dynamic(() => import('@lemonade-hq/cdk').then(mod => mod.ResponsiveText), { ssr: false });

export const Title = styled(LegacyText).attrs<unknown>({
  fontSize: ['2.8rem', '2.8rem', '4.4rem'],
  fontWeight: 'bold',
  lineHeight: 1.25,
  type: 'main',
  as: 'h2',
})`
  text-wrap: balance;
`;

export const ResponsiveTitle = styled(ResponsiveText).attrs<unknown>({
  fontSize: ['2.8rem', '2.8rem', '4.4rem'],
  fontWeight: 'bold',
  lineHeight: 1.25,
  type: 'main',
})``;

export const Subtitle = styled(LegacyText).attrs<unknown>({
  fontSize: ['2rem', '2rem', '1.8rem'],
  lineHeight: [1.4, 1.4, 1.55],
  type: 'main',
})``;

export const ResponsiveSubtitle = styled(ResponsiveText).attrs<unknown>({
  fontSize: ['2rem', '2rem', '1.8rem'],
  lineHeight: [1.4, 1.4, 1.55],
  type: 'main',
})``;
